import type { EventStructure } from "../types";

export function attachBehavioralInference(event: EventStructure) {
  let result = { string: "", words: { 1: "", 2: "", 3: "" } };

  // Step 1: Infer Interaction Stage
  if (
    event.journey.length > 5 &&
    event.behavior.attributes.productIntentConcentration === "Low"
  ) {
    result.words[1] = "Explorer";
  } else if (
    event.behavior.attributes.startToFirstAddToCartLag === "High" &&
    event.behavior.attributes.sessionDuration > "180"
  ) {
    result.words[1] = "Returner";
  } else if (
    event.behavior.attributes.scrollDepthPercentage === "Deep" &&
    event.behavior.attributes.hoverToClickRatio === "Click-Dominant"
  ) {
    result.words[1] = "Researcher";
  } else if (
    event.behavior.attributes.scrollStopFrequency === "High" &&
    event.behavior.attributes.addToCartVelocity === "Fast"
  ) {
    result.words[1] = "Frequent";
  } else if (
    event.behavior.attributes.startToFirstAddToCartLag === "High" &&
    event.behavior.attributes.timeOnPage === "Bounce"
  ) {
    result.words[1] = "First-Timer";
  } else if (
    event.inferredTags.tags?.activities?.includes("Shopping") &&
    event.journey.length > 4
  ) {
    result.words[1] = "Seasonal";
  } else if (
    event.behavior.attributes.interactionConsistency === "High" &&
    event.behavior.attributes.cartInteractionDepth === "Moderate"
  ) {
    result.words[1] = "Reactivator";
  }

  // Step 2: Infer Engagement Type
  if (
    event.behavior.attributes.hoverToClickRatio === "Click-Dominant" &&
    event.behavior.attributes.scrollDepthPercentage === "Shallow"
  ) {
    result.words[2] = "Click-Focused";
  } else if (
    event.behavior.attributes.scrollDepthPercentage === "Deep" &&
    event.behavior.attributes.hoverToClickRatio === "Hover-Dominant"
  ) {
    result.words[2] = "Scroll-Driven";
  } else if (
    event.behavior.attributes.hoverToClickRatio === "Hover-Dominant" &&
    event.behavior.attributes.productIntentConcentration === "Moderate"
  ) {
    result.words[2] = "Hover-Intent";
  } else if (
    event.behavior.attributes.scrollStopFrequency === "High" &&
    event.behavior.attributes.addToCartVelocity === "Moderate"
  ) {
    result.words[2] = "Media-Engaged";
  } else if (
    event.persona.attributes.platform === "mobile" &&
    event.behavior.attributes.interactionConsistency === "Moderate"
  ) {
    result.words[2] = "Mobile-Active";
  } else if (
    event.persona.attributes.platform === "web" &&
    event.behavior.attributes.interactionConsistency === "Consistent"
  ) {
    result.words[2] = "Desktop-Engaged";
  } else if (
    event.behavior.attributes.timeOnPage === "Short" &&
    event.behavior.attributes.cartInteractionDepth === "Low"
  ) {
    result.words[2] = "Quick-View";
  } else if (
    event.behavior.attributes.productIntentConcentration === "High" &&
    event.behavior.attributes.scrollStopFrequency === "Moderate"
  ) {
    result.words[2] = "Review-Focused";
  } else if (
    event.behavior.attributes.interactionConsistency === "Consistent"
  ) {
    result.words[2] = "Consistent-Browser";
  }

  // Step 3: Infer Purchase Intent
  if (
    event.ecommerce.attributes.cartAbandonmentRate === "High" &&
    event.ecommerce.attributes.likelihoodToConvert < 20
  ) {
    result.words[3] = "No Intent to Buy";
  } else if (
    event.behavior.attributes.productIntentConcentration === "Moderate" &&
    event.ecommerce.attributes.crossSellPotential > 30
  ) {
    result.words[3] = "Considering Purchase";
  } else if (
    event.ecommerce.attributes.upSellPotential > 50 &&
    event.ecommerce.attributes.checkoutCompletionRate > 30
  ) {
    result.words[3] = "Good Intent to Buy";
  } else if (
    event.ecommerce.attributes.discountSensitivity > 60 &&
    event.ecommerce.attributes.abandonedCartRecoveryLikelihood > 50
  ) {
    result.words[3] = "Deal-Oriented";
  } else if (
    event.ecommerce.attributes.propensityToPay < 40 &&
    event.ecommerce.attributes.discountSensitivity > 60
  ) {
    result.words[3] = "Price-Sensitive";
  } else if (
    event.ecommerce.attributes.averageOrderValue > 200 &&
    event.ecommerce.attributes.priceElasticity < 20
  ) {
    result.words[3] = "High-Spender";
  } else if (
    event.ecommerce.attributes.bundlePurchaseLikelihood > 50 &&
    event.ecommerce.attributes.crossSellPotential > 50
  ) {
    result.words[3] = "Interested in Bundles";
  } else if (
    event.behavior.attributes.frequentCartModifications === "High" &&
    event.ecommerce.attributes.repeatPurchaseLikelihood > 30
  ) {
    result.words[3] = "Loyal Buyer";
  } else if (
    event.behavior.attributes.frequentCartModifications === "Moderate" &&
    event.ecommerce.attributes.subscriptionLikelihood > 50
  ) {
    result.words[3] = "Subscription-Ready";
  } else if (
    event.behavior.attributes.addToCartVelocity === "Fast" &&
    event.behavior.attributes.startToFirstAddToCartLag === "Low"
  ) {
    result.words[3] = "Impulse Buyer";
  } else if (
    event.ecommerce.attributes.discountSensitivity > 60 &&
    event.behavior.attributes.hoverToClickRatio === "Click-Dominant"
  ) {
    result.words[3] = "Value-Seeker";
  }

  // Final combined behavioral inference string
  result.string =
    `${result.words[1].trim()} ${result.words[2].trim()} ${result.words[3].trim()}`.trim();

  // Assign to event object for behavior description
  event.sessionDescription.behavior = result.string;

  return event;
}
